import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import UserProfile from "components/UserProfile/UserProfile";
import $ from 'jquery';
import routes from "routes.js";
import axios from 'axios';
import { saveAs } from 'file-saver';
import { apiUrl } from 'config';
import toast, { Toaster } from "react-hot-toast"


const API = (function() {
    var getData = async function(url)
    {
      const token = await UserProfile.getToken();
      let headers = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
      };

      try {
        const response = await axios.get(apiUrl+url, headers);
        return response.data;
      } 
      catch (error) {

        if (error.response && error.response.status === 401) {
          await localStorage.removeItem("user");
          window.location.href = '/login';
          toast.error("Authorization token is expired or invalid")
          return {"status":false, "msg":"Authorization token is expired or invalid", "data":""}
        }
        if (error.response && error.response.status === 403) {
          toast.error(error.response.data)
          return {"status":false, "msg":error.response.data, "data":""}
        } else {
          return {"status":false, "msg":"Error fetching data from server", "data":""}
        }
      }
    }

    var postData = async function(url,data,blob)
    {
      const token = await UserProfile.getToken();
      let headers = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
      };
      if (blob)
      {
        headers["responseType"] = "blob";
      }

      try {
        const response = await axios.post(apiUrl+url, data, headers);
        return response.data;
      } 
      catch (error) {
   
        if (error.response && error.response.status === 401) {
          await localStorage.removeItem("user");
          window.location.href = '/login';
          toast.error("Authorization token is expired or invalid")
          return {"status":false, "msg":"Authorization token is expired or invalid", "data":""}
        }
        if (error.response && error.response.status === 403) {
          toast.error(error.response.data)
          return {"status":false, "msg":error.response.data, "data":""}
        } else {
          return {"status":false, "msg":"Error fetching data from server", "data":""}
        }
      }
    }

    var sseData = async function(endpoint)
    {
      const token = await UserProfile.getToken();
      let eventSource = new EventSource(apiUrl+endpoint)
      return eventSource
    }

    return {
        getData:getData,
        postData:postData,
        sseData:sseData
    }

})();

export default API;
